<template>
	<div class="indicator_item" @click="$emit('click')">
		<div class="indicator_item_header">
			<h3 class="indicator_item_title">
				<span>{{ title }}</span>
				<span class="tag" :class="$status.bloodStatus[status]" v-if="status">
					{{ $status.bloodStatusStr[$status.bloodStatus[status]] }}
				</span>
			</h3>
			<div class="indicator_item_time">
				<span>{{ getRecordTime }}</span>
			</div>
		</div>

		<div class="indicator_item_main">
			<span class="indicator_empty" v-if="!recordTime">暂无记录</span>
			<slot v-else></slot>
		</div>
	</div>
</template>

<script>
export default {
    name: 'indicator-item',
    props: {
        title: {
            type: String,
            default: ''
        },
        status: {
            type: [String, Number],
            default: ''
        },
        recordTime: {
            type: String,
            default: ''
        }
    },
    computed: {
        getRecordTime () {
            if (!this.recordTime) return null
            const recordTime = this.$moment(this.recordTime).format('x')
            const poor = this.$store.state.account.serveDateTime - recordTime
            if (poor < 1000 * 60) return '刚刚'
            if (poor < 1000 * 60 * 60) return `${Math.floor(poor / 1000 / 60)}分钟前`
            if (poor < 1000 * 60 * 60 * 24) return `${Math.floor(poor / 1000 / 60 / 24)}小时前`
            return this.recordTime.substring(this.recordTime.indexOf('-') + 1, this.recordTime.lastIndexOf(':'))
        }
    }
};
</script>

<style scoped lang="less">
.indicator_item {
	// display: flex;
	// flex-direction: column;
	// justify-content: space-between;
	height: 190px;
	box-sizing: border-box;
	padding: 24px;
	border-radius: 16px;
	background-color: #e6f6f7;
	&_header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.indicator_item_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 39px;
		line-height: 39px;
		font-size: 28px;
		color: #1f2329;
		.tag {
			padding: 0 8px;
			height: 34px;
			line-height: 36px;
			font-size: 24px;
			border-radius: 4px;
			background-color: @white;
			margin-left: 12px;
			&.normal {
				background-color: @primary;
				color: #fff;
			}
			&.high {
				background-color: @danger;
				color: #fff;
			}
			&.low {
				background-color: @info;
				color: #fff;
			}
		}
	}
	.indicator_item_main {
		margin-top: 27px;
		.indicator_empty {
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			color: @gray-9;
		}
	}
	.indicator_item_time {
		white-space: nowrap;
		height: 34px;
		line-height: 34px;
		font-size: 20px;
		color: #8f959e;
	}
}
</style>
